import { render, staticRenderFns } from "./EditInvoicesDataForm.vue?vue&type=template&id=15ba5e50&"
import script from "./EditInvoicesDataForm.vue?vue&type=script&lang=ts&"
export * from "./EditInvoicesDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports